import { curry, intersection, length } from 'ramda';

export default curry((value, items) => length(intersection(value, items)) === length(value));
